import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

//cookies
import {get_cookies} from "../../../components/Cookies/Cookies";
import numeral from "numeral";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const CollectionHistory = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
	});
	const classes = useStyles();

	const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));

	// Data Fetching
	useEffect(() => {
		data();
	}, []);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);
	//search button
	const dataFilter = async () => {
		setDataLoaded(false);
        await axios.get(
			process.env.REACT_APP_API_URL+'collection_transaction_history', {
            params:{
                date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_user_id_no: useridNo,  
            }
        }).then((res)=>{
			setPosts(res.data.data);
		}).catch((error)=>{
		//console.log(error.message);
		})
		setDataLoaded(true);
    }

	const data = async () => {
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};
	const columns = [
		{
			name: "id",
			label: "ID",
		},
		{
			name: "date",
			label: "Date",
		},
		{
			name: "name",
			label: "Name",
		},
		{
			name: "amount",
			label: "Amount",
			sort:true, 
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
					);
				  }
				}
		},
		{
			name: "balance",
			label: "Balance",
			sort:true, 
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
					);
				  }
				}
		},
		{
			name: "status",
			label: "Status",
		},
		{
			name: "action",
			label: "Action",
			options: {
				download: false, //exclude this column in csv export
				sort:false, 
				filter: false, 
				customBodyRenderLite: (dataIndex) => {
					let id =  posts[dataIndex].id;
					let status =  posts[dataIndex].status;
					// collectionviewdetails
					// collectionallocate
				if(status==="Full Allocation"){
						return(
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12} md={12} lg={5} xl={4}>
									<NavLink to={"/sales/collection-history-view/"+id+"/"+useridNo}>
										<Button variant="contained" color="primary">
											View
										</Button>	
									</NavLink> 
								</Grid>
							</Grid>
						)
				}else{
						return(
							<Grid container spacing={1}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={4}>
										<NavLink to={"/sales/collection-history-view/"+id+"/"+useridNo}>
											<Button variant="contained" color="primary">
												View
											</Button>	
										</NavLink> 
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={4}>
										<NavLink to={"/sales/collection-history-allocate/"+id+"/"+useridNo}>
											<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}>
												Allocate
											</Button>	
										</NavLink> 
									</Grid>
							</Grid>
						)
					}
				},
			},
	 	}
	];

	const options = {
		filter: true,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		download: downloadFlag,  //add this
		print: downloadFlag, //add this
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		downloadOptions: {
			filename : 'CollectionTransactionHistory.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<NavLink to={"/sales"}><h4 style={{color:"#339933"}}>Sales</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Collection Transaction History</h4>
			</div>
			<div className="page-container">
				<div style={style}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>
                            <Grid item xs={4} lg={1} xl={1}>
                                <Button variant="contained" style ={{marginTop: "23px"}} color="primary"  onClick={() => {dataFilter()}}>Search</Button>
                            </Grid>
                        </Grid>        
                    </div>

				{!dataLoaded ? (
					<Preloader />
				) : (
						<MUIDataTable
							title={
								<div>
							
									<div className="table-title">
									Collection Transaction History
									</div>
								</div>
							}
							data={posts}
							columns={columns}
							options={options}
						/>
				)}
			</div>
		</div>
	);
};

export default CollectionHistory;